/**
 * TanStack Query hook for `GET /api/cro/opps-created` (2026-07-10, demo feedback).
 *
 * Feeds the CRO "Opps Created (trailing 90 days)" tile: count + current-stage mix
 * + $ created, with field-history-reconstructed WoW/MoM. Mirrors useCroArrPacing.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MetricError } from './useCroScorecard.js';
import type { CroOppsCreatedResponse } from '@saledash/shared';

export function useCroOppsCreated(): UseQueryResult<CroOppsCreatedResponse, MetricError> {
  return useQuery<CroOppsCreatedResponse, MetricError>({
    queryKey: ['cro', 'opps-created'],
    queryFn: ({ signal }) =>
      apiFetch<CroOppsCreatedResponse>('/api/cro/opps-created', { signal }),
    staleTime: 60_000,
    retry: 2,
  });
}
